/*
 * Filename: user-details-store.ts
 * Description: this file act as a store to save data of user.
 */
import { UserDetails } from './models/user-info.model';


/** 
 * @description App Store Creation
 */
export const UserDetailsStore = UserDetails.create({
    UserDetailsObject:{
        email: '',
        first_name: '',
        last_name: '',
        mobile_phone: '',
        username: '',
        fullName: '',
        versionNumber: ''
    }
});

export type IUserDetailsStore = typeof UserDetails.Type;
